import React from 'react';
import {
  Row,
  StyledFirstColumn,
  StyledPaperContainer,
  StyledSecondColumn,
  StyledSectionTitle
} from '../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { ColumnWithGap } from '../../../PlusWebsiteEditor/sections/HeroBlock/HeroBlock.styled';
import { ClinicFormProps } from '../types';
import ClinicPromoEditor from './ClinicPromotionalContent';
import TextEditor from '../../../FormEditors/TextEditor';
import SwitchEditor from '../../../FormEditors/SwitchEditor';
import CloneClinicSelector from './CloneClinic/CloneClinicSelector';
import EsignatureToggle from './EsignatureToggle';

const CreateClinicBody = ({ form, selectedClinicToClone, onClinicToCloneChange, isCreateMode = false }: ClinicFormProps) => {
  return (
    <Row>
      <MainInformation
        form={form}
        selectedClinicToClone={selectedClinicToClone}
        onClinicToCloneChange={onClinicToCloneChange}
        isCreateMode={isCreateMode}
      />
      <StyledSecondColumn>
        <Integration form={form} />
      </StyledSecondColumn>
    </Row>
  );
};

const MainInformation = ({ form, selectedClinicToClone, onClinicToCloneChange, isCreateMode = false }: ClinicFormProps) => {
  return (
    <StyledFirstColumn>
      {isCreateMode && (
        <CloneClinicSelector
          form={form}
          selectedClinicToClone={selectedClinicToClone}
          onClinicToCloneChange={onClinicToCloneChange}
        />
      )}
      <ClinicInformation form={form} />
      <ClinicPromoEditor form={form} isCreateMode={isCreateMode} />
    </StyledFirstColumn>
  );
};

const ClinicInformation = ({ form }: ClinicFormProps) => (
  <StyledPaperContainer>
    <ColumnWithGap>
      <StyledSectionTitle>Clinic Information</StyledSectionTitle>
      <TextEditor label="Clinic Name" control={form.control} name="name" />
      {form.formState.defaultValues?.selection_visibility === 'global_default' && (
        <div><b>(Global default clinic)</b></div>
      )}
    </ColumnWithGap>
  </StyledPaperContainer>
);

const Integration = ({ form }: ClinicFormProps) => (
  <StyledPaperContainer>
    <StyledSectionTitle>Integration</StyledSectionTitle>
    <SwitchEditor control={form.control} name="internal_prescribing" label="Internal prescribing" />
    <SwitchEditor control={form.control} name="internal_product_charge" label="Internal product charge" />
    <EsignatureToggle form={form} />
  </StyledPaperContainer>
);

export default CreateClinicBody;
